<template>
    <div class="kslb" v-loading.fullscreen.lock="loading">
        <div style="float: right; margin: 10px 10px 30px 0" v-if="show">
            <el-button type="primary" @click="open"><i class="el-icon-delete el-icon--left"></i>删除科室</el-button>
        </div>
        <div class="my-table" v-if="show">
            <el-table
                      :data="tableData"
                      stripe
                      style="width: 100%"
                      height="650px"
                      :header-cell-style="headerCellStyle"
                      @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column label="科室" prop="name"> </el-table-column>
                <el-table-column label="科室编码" prop="code"> </el-table-column>
                <el-table-column label="操作">
                    <template #default="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">修改名称</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="width: 100%; height: 100%; display: flex; justify-content: center"
             v-if="!show">
            <div style="margin: 200px 0 50px 0">
                <div style="display: flex; align-items: center; margin-bottom: 20px">
                    <div style="width: 200px">科室新名称:</div>
                    <el-input v-model="name" placeholder="科室新名称"></el-input>
                </div>
                <div style="display: flex; align-items: center">
                    <div style="width: 200px">科室新编码:</div>
                    <el-input v-model="code" placeholder="科室新编码"></el-input>
                </div>
                <div class="button">
                    <el-button @click="save">保存</el-button>
                    <el-button @click="goback">取消</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getDivs,divEdit,divDelete } from '@/api/div.js';

    export default {
        name: "kslb",
        data() {
            return {
                loading: true,
                tableData: [],
                show: true,
                name: "",
                code: "",
                id: "",
                type: "",
                deleteItem: "",
            };
        },
        created() {
            this.init();
        },
        methods: {
            open() {
                this.$confirm("此操作将永久删除科室, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.deleteKs();
                    })
                    .catch(() => { });
            },
            async deleteKs() {
                const self = this;
                let table = self.tableData;
                self.loading = true;
                if (self.deleteItem.length !== 0) {
                    for(let a = 0;a<self.deleteItem.length;a++){
                        let res = await divDelete({id:self.deleteItem[a].id})
                        if(res.status == 0){
                            table = table.filter(ele=>ele.id !== self.deleteItem[a].id)
                            self.$message.success("删除成功!");
                        }
                    }
                    self.tableData = table
                    self.loading = false;
                }
            },
            handleSelectionChange(val) {
                this.deleteItem = val;
            },
            save() {
                this.loading = true;
                divEdit({
                        id: this.id,
                        code: this.code,
                        name: this.name,
                        type: this.type,
                    })
                    .then((res) => {
                        if (res.status == 0) {
                            this.$message.success("修改成功!");
                            this.goback();
                            this.getDivs();
                        }
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
                // }
            },
            goback() {
                this.show = true;
                this.name = "";
                this.code = "";
            },
            headerCellStyle() {
                return { height: "90px", background: "#E5F2FF" };
            },
            handleClick(row) {
                this.show = false;
                this.id = row.id;
                this.type = row.type;
            },
            init() {
                getDivs().then(res => {
                    if (res.status == 0) {
                        this.tableData = res.divs.filter((e) => e.type == 1);
                    }
                    this.loading = false;
                }).catch(err=>{
                    this.loading = false;
                })
            },
            getDivs() {
                this.loading = true;
                getDivs()
                    .then((res) => {
                        if (res.status == 0) {
                            this.tableData = res.divs.filter((e) => e.type == 1);
                        }
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            },
        },
    };
</script>

<style scoped>
    .kslb {
        height: 500px;
        width: 80%;
        margin: 0 auto;
        margin-top: 50px;
    }

    .button {
        margin-top: 50px;
        display: flex;
        justify-content: center;
    }
</style>